<ng-container *ngFor="let filter of filters; let idx = index">
  <div class="px-3 px-md-4 py-3 mb-1">
    <h6
      *ngIf="filter?.displayName; else titleSkeletonTml"
      class="d-inline text-dark mb-0"
      data-e2e="skeleton-filter-name"
    >
      {{ filter.displayName }}
    </h6>

    <ng-template #titleSkeletonTml>
      <atx-skeleton-basic
        class="skeleton-title skeleton-title-hight skeleton-title-width"
        [style.height]="'skeleton-title-hight'"
        [style.width]="'skeleton-title-width'"
      ></atx-skeleton-basic>
    </ng-template>

    <fa-icon
      *ngIf="filter?.displayName"
      class="d-inline-block ml-1"
      [class.rotated]="hasValues(idx)"
      [icon]="['fas', 'angle-right']"
    ></fa-icon>

    <div class="d-flex mt-2" *ngIf="hasValues(idx)">
      <ng-container *ngFor="let i of filterValuesSkeletonNumber">
        <atx-skeleton-basic
          class="
            mr-2
            skeleton-button skeleton-button-hight skeleton-button-width
          "
          [class.skeleton-button-rounded]="idx > 0"
          [style.height]="'skeleton-button-hight'"
          [style.width]="'skeleton-button-width'"
        ></atx-skeleton-basic>
      </ng-container>
    </div>
  </div>
</ng-container>
